// extracted by mini-css-extract-plugin
var _1 = "EmailProfileWidgetCopiedTo-moduledivider__lwmua Divider-moduleDivider__dL3Vg";
export { _1 as "divider" }
